import { useState } from 'react';
import type { ArTaskRow } from '@erp/rpc';
import { openTaskRow } from './arTasksPageState';

/** {@link openTaskRow}, remembering the last row seen for the open task. */
export function useOpenTaskRow(
  rows: readonly ArTaskRow[],
  taskId: string | null,
): ArTaskRow | undefined {
  const [remembered, setRemembered] = useState<ArTaskRow>();
  const row = openTaskRow(rows, taskId, remembered);
  if (row && row !== remembered) setRemembered(row);
  return row;
}
